import React from 'react';

import {Box, Typography} from '@mui/material';

import './styles';

const SecureEncryptFooter: React.FC = ({}) => {
  return (
    <Box className="security-container">
      <Box className="security-image-container">
        <Box
          component="img"
          src="/assets/icons/secure-encrypt.svg"
          sx={{
            width: 29,
            height: 29,
          }}
        />
        <Box className="security-labels-container">
          <Typography className="security-title">SECURE</Typography>
          <Typography className="security-subtitle">TLS ENCRYPTION</Typography>
        </Box>
      </Box>
      <Typography className="security-text">
        We encrypt your data with TLS level security, scrambling it into an
        unreadable code to keep your privacy safe online.
      </Typography>
    </Box>
  );
};

export default SecureEncryptFooter;
